import _React from 'react'
import _styled from 'styled-components'
import _i18n from 'localization/i18n'

export const React = _React
export const styled = _styled
export const i18n = _i18n
